// eslint-disable-next-line no-restricted-imports
import type { FieldValues } from 'react-hook-form';

import type { ObjectDotNotation } from '@luna/utils-ts';

type FormValidationValueMap<FormValues = void> = Record<
    ObjectDotNotation<FormValues>,
    string | undefined
>;

function isEmptyObject(value: any) {
    return typeof value === 'object' && Object.keys(value).length === 0;
}

const mapValuesToDotNotationRecursion = <FormValues extends FieldValues>(
    values: FormValues,
    currentPath = '',
): FormValidationValueMap<FormValues> => {
    return Object.entries(values).reduce((acc, [key, currentValues]) => {
        const newPath = `${currentPath}.${key}`;

        if (
            typeof currentValues !== 'object' ||
            currentValues === null ||
            isEmptyObject(currentValues)
        ) {
            // remove first dot in the path
            const path = newPath.replace(/^\./, '') as ObjectDotNotation<FormValues>;

            return { ...acc, [path]: currentValues };
        }

        return {
            ...acc,
            ...mapValuesToDotNotationRecursion(currentValues, newPath),
        };
    }, {} as FormValidationValueMap<FormValues>);
};

export const mapValuesToDotNotation = <FormValues extends FieldValues>(
    values: FormValues,
): FormValidationValueMap<FormValues> => mapValuesToDotNotationRecursion<FormValues>(values);
